<template>
  <div id="opinion">
    <bread :content="breadContent"></bread>
    <p class="Page-title">观点摘要</p>
    <el-divider></el-divider>
    <div id="content">
      <div id="left">
        <opinion-card v-for="(item,index) in showTable" :key="index" :item="item"></opinion-card>
        <el-pagination class="page" background layout="prev, pager, next,jumper" :total="summary.length" :page-size="5" @current-change="handleCurrentChange" :current-page="tableIndex">
        </el-pagination>
      </div>
      <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'最新观点'" :titleColor="'red'"></timeline>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import timeline from "@/components/timeline";
import opinionCard from "@/components/academic/opinionCard";
import Api from "@/network.js";
export default {
  name: "opinion",
  components: {
    bread,
    timeline,
    opinionCard
  },
  async beforeRouteEnter(from, to, next) {
    let resTimeData = await Api.index.getLast("summary_of_view");
    let res = (await Api.academic.getOpinions()) || [];
    next(vm => {
      vm.summary = res;
      vm.showTable = vm.summary.slice(0, 5);
      for (let item of resTimeData) {
        vm.timelineData.list.push({
          date: item.Date,
          content: item.Title,
          url: `/academic/opinion/opnDetail?id=${item.Id}`
        });
      }
    });
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "学术交流", routerName: "academic" },
        { text: "观点摘要", routerName: "opinion" }
      ],
      summary: [],
      showTable: [],
      timelineData: {
        title: "最新观点",
        iconSrc: require("../../assets/fire-icon.png"),
        list: []
      },
      tableIndex: 1
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.showTable = this.summary.slice((index - 1) * 5, index * 5);
    }
  }
};
</script>
  
<style lang="scss" scoped>
#opinion {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
  overflow: hidden;
}
.opinionCard {
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px rgb(219, 219, 219) solid;
}
#content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  #left {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: calc(100% - 300px);
    .opinionCard {
      width: 100%;
    }
  }
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
  margin-bottom: 5px;
}
</style>

